import type { Me } from '@/api'

/**
 * A sign-up, told to the tag manager the deployment loads (`PORTAL_GTM_ID`, infra/scripts/os-portal.mjs): the
 * `sign_up` event on its data layer, once, the first time a session that founded an enterprise (#2218) opens the
 * portal. A container decides what becomes of it, such as an analytics key event. It carries no name, address or id.
 *
 * Nothing is sent without a data layer, so a deployment with no container sends nothing. The founding is remembered in
 * this browser, so a reload, or another tab of the same session, never counts it twice.
 */
const KEY_PREFIX = 'os:sign-up-sent:'

type TagWindow = { dataLayer?: unknown[] }

export function sendSignUpEvent(person: Me | null, win: TagWindow = window as TagWindow): void {
    const founded = person?.foundedEnterprise
    if (!founded || !Array.isArray(win.dataLayer)) {
        return
    }
    try {
        if (localStorage.getItem(KEY_PREFIX + founded.id) === '1') {
            return
        }
        localStorage.setItem(KEY_PREFIX + founded.id, '1')
    } catch {
        // Without browser storage a reload could count the sign-up twice, so it is not counted at all.
        return
    }
    win.dataLayer.push({ event: 'sign_up' })
}
